import React, { useRef } from "react";
import {
  RideTextField,
  RideGlUserSolid,
} from "@rimac-seguros/ride-system-components";
import Regex from "@/utils/regex";
import "./styles.scss";
import { useSelector } from "react-redux";
import { formatAndMaskFullName } from "@/utils/format-name";

const FormContact = ({
  register,
  errors,
  setValue,
  setEmailWithoutMask,
}) => {
  const wasFirstFocus = useRef(false);
  const { userData } = useSelector((state) => state.vida);
  const {
    documento: documentNumber,
    nombres: names,
    apellidoPaterno: paternalSurname,
    apellidoMaterno: maternalSurname,
  } = userData;
  const fullName = formatAndMaskFullName(names, paternalSurname, maternalSurname);

  const handleEmailFocus = () => {
    if (wasFirstFocus.current) return;

    setValue("email", "");
    wasFirstFocus.current = true;
  };

  const handleEmailBlur = (e) => {
    setEmailWithoutMask(e.target.value);
    setValue("email", e.target.value);
  };

  return (
    <div id="form-contact" className="form-contact">
      <h3>Datos personales</h3>
      <div className="flex gap-ride-gl-spacing-large md:gap-ride-gl-spacing-medium rounded-ride-gl-border-radius-medium px-ride-gl-spacing-xlarge py-ride-gl-spacing-2xlarge md:py-ride-gl-spacing-xlarge bg-ride-sys-color-surface-highlight-subtle-attribute mb-ride-gl-spacing-2xlarge">
        <RideGlUserSolid size="medium" />
        <div className="flex flex-col gap-ride-gl-spacing-small">
          <p className="ride-sys-text-paragraph-medium-regular-short">
            <span className="font-ride-gl-font-weight-semibold block md:inline-block">
              Nombres y apellidos:
            </span>{" "}
            {fullName}
          </p>
          <p className="ride-sys-text-paragraph-medium-regular-short">
            <span className="font-ride-gl-font-weight-semibold">DNI:</span>{" "}
            {documentNumber}
          </p>
        </div>
      </div>
      <div className="form-contact_content">
        <div className="form-contact_input">
          <RideTextField
            {...register("email", {
              required: true,
              pattern: Regex.email,
            })}
            aria-required
            label="Correo electrónico"
            size="large"
            onBlur={handleEmailBlur}
            onFocus={handleEmailFocus}
            error={!!errors?.email}
            errorMessage={
              errors?.email?.type === "required"
                ? "Este campo es obligatorio"
                : "Ingresa un correo válido"
            }
          />
        </div>
        <span className="ride-sys-text-label-small-regular text-ride-sys-color-text-extreme lg:mb-0 lg:w-1/2">
          Al continuar, aceptas que la póliza del seguro y las comunicaciones
          relacionadas se envíen al correo electrónico ingresado.
        </span>
      </div>
    </div>
  );
};

export default FormContact;
